/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Subject_Sorting_LotInputs */

const vi_print_admin_subject_sorting_lot = /** @type {(inputs: Print_Admin_Subject_Sorting_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô phân loại`)
};

/**

* @param {Print_Admin_Subject_Sorting_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_subject_sorting_lot = /** @type {((inputs?: Print_Admin_Subject_Sorting_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Subject_Sorting_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_subject_sorting_lot(inputs)
});